const MS_PER_DAY = 24 * 60 * 60 * 1000

/**
 * Whole days elapsed since an incident report entered In Progress.
 * Accepts the ISO string the API returns (or a Date); invalid input -> 0.
 */
export function getDaysInProgress(
  inProgressSince: string | Date,
  now: Date = new Date(),
): number {
  const since = new Date(inProgressSince).getTime()
  if (Number.isNaN(since)) return 0
  return Math.max(0, Math.floor((now.getTime() - since) / MS_PER_DAY))
}

/**
 * e.g. 5 -> "5 days", 1 -> "1 day"
 */
export function formatDaysInProgress(days: number): string {
  return `${days} ${days === 1 ? 'day' : 'days'}`
}
